import { mergeAttributes } from "@tiptap/core"
import TiptapParagraph from "@tiptap/extension-paragraph"

export const DROP_CAP_MIN_LENGTH = 200

export const Paragraph = TiptapParagraph.extend({
  renderHTML({ node, HTMLAttributes }) {
    const attrs =
      node.textContent.length > DROP_CAP_MIN_LENGTH
        ? mergeAttributes(HTMLAttributes, { "data-drop-cap": "" })
        : HTMLAttributes
    return ["p", mergeAttributes(attrs), 0]
  },
})
